import React, { useState } from 'react';
import BugReportModal from './BugReportModal';
import { useResponsive } from '../hooks/useResponsive';
import packageJson from '../../package.json';

const Footer = () => {
  const { isDesktop } = useResponsive();
  const [showBugReport, setShowBugReport] = useState(false);
  const version = packageJson.version;

  const styles = {
    footer: {
      padding: isDesktop ? '20px 40px' : '16px',
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #e0e0e0',
      textAlign: 'center',
      fontSize: '12px',
      color: '#666',
    },
    content: {
      display: 'flex',
      flexDirection: isDesktop ? 'row' : 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: isDesktop ? '16px' : '8px',
    },
    versionText: {
      margin: 0,
    },
    separator: {
      display: isDesktop ? 'inline' : 'none',
      color: '#ccc',
    },
    betaBadge: {
      backgroundColor: '#ffc107',
      color: '#000',
      padding: '2px 8px',
      borderRadius: '4px',
      fontWeight: '600',
      fontSize: '11px',
    },
    reportLink: {
      color: '#007bff',
      textDecoration: 'none',
      cursor: 'pointer',
      fontWeight: '500',
    },
  };

  return (
    <>
      <footer style={styles.footer}>
        <div style={styles.content}>
          <span style={styles.versionText}>Reps Over Rings v{version}</span>
          <span style={styles.separator}>•</span>
          <span style={styles.betaBadge}>BETA</span>
          <span style={styles.separator}>•</span>
          <a style={styles.reportLink} onClick={() => setShowBugReport(true)}>
            Report Bug
          </a>
        </div>
      </footer>

      {showBugReport && <BugReportModal onClose={() => setShowBugReport(false)} />}
    </>
  );
};

export default Footer;
